<template>
  <div class="header bg-gradient-primary main-route">
    <notifications></notifications>
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
// @media only screen and (min-width: 1200px) {
.main-route {
  height: 100vh;
}
// }
</style>